import { render, staticRenderFns } from "./PregnancyAdvice.vue?vue&type=template&id=4fd2b4c5&scoped=true&"
import script from "./PregnancyAdvice.vue?vue&type=script&lang=ts&"
export * from "./PregnancyAdvice.vue?vue&type=script&lang=ts&"
import style0 from "./PregnancyAdvice.vue?vue&type=style&index=0&id=4fd2b4c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2b4c5",
  null
  
)

export default component.exports